var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network-issues"},[_c('h1',[_vm._v("Упс, скорее всего у Вас проблемы с сетью.")]),_c('p',[_vm._v("Пожалуйста вернитесь на главную и попробуйте с начала.")]),_c('router-link',{staticClass:"home-link",attrs:{"to":{ name: 'home' }}},[_vm._v("На главную")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }